import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAppDispatch } from '../store';
import { clearAuth, useAuthState, useIsAuthenticated, useAuthUser } from '../store/slices/authSlice';
import apiClient from '../utils/api/ApiClient';

/**
 * Custom hook for authentication management
 * Now uses Redux for state management
 */
export function useAuth() {
    const navigate = useNavigate();
    const dispatch = useAppDispatch();
    const authState = useAuthState();
    const isAuthenticated = useIsAuthenticated();
    const user = useAuthUser();

    const logout = useCallback(() => {
        // Clear auth from Redux and localStorage
        dispatch(clearAuth());
        
        // Clear token from apiClient
        apiClient.clearAuthToken();
        
        // Navigate to login
        navigate('/login');
    }, [dispatch, navigate]);

    return {
        isAuthenticated,
        user,
        phoneNumber: user?.phone || null,
        loading: authState.loading,
        error: authState.error,
        logout,
    };
}
